import { BodyText, Callout, Skeleton } from "@/components/ui";
import { useInView } from "react-intersection-observer";

import { useFilesContext } from "../FilesContext";
import { FilePreview } from "./FilePreview";

export const FilesGrid = () => {
  const {
    isLoadingFiles,
    isFetchingNextPage,
    filteredFiles,
    hasNextPage,
    fetchNextPage,
    isError,
    refetch,
  } = useFilesContext();

  const { ref } = useInView({
    onChange: (inView) => {
      if (inView) {
        fetchNextPage();
      }
    },
  });

  if (isError) {
    return (
      <div className="mt-3">
        <Callout
          className="w-full cursor-pointer"
          variant="danger"
          title="Unable to load files!"
          description="Please click here to try again. If the problem persists, please use the feedback tool to report the issue."
          onClick={() => refetch()}
        />
      </div>
    );
  }

  return (
    <div className="mt-3 grid lg:grid-cols-2 xl:grid-cols-3 gap-3 overflow-auto pb-3 h-fit">
      {isLoadingFiles &&
        filteredFiles.length === 0 &&
        Array.from({ length: 6 }).map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: loading skeletons don't have stable ids
          <div key={i}>
            <Skeleton className="aspect-square h-fit" />
            <Skeleton className="h-8 w-full mt-2" />
          </div>
        ))}

      {!isLoadingFiles && !isFetchingNextPage && filteredFiles.length === 0 && (
        <BodyText size="sm" textColor="tertiary">
          No files found
        </BodyText>
      )}

      {filteredFiles.map((file) => (
        <FilePreview
          key={file.content?.[0]?.attachment?.url || file.id}
          file={file}
        />
      ))}

      {(isFetchingNextPage || hasNextPage) && (
        <div ref={hasNextPage ? ref : undefined} className="visbility-hidden" />
      )}
    </div>
  );
};
